module.exports = __webpack_public_path__ + "static/media/company_logo_ru.cacb5ef3.png";